module.exports = {"updown_read_key":"ro-B6Y8kudSkgvec86S3MUp","twitter":"presswizards","website_name":"Press Wizards® Server","website_url":"https://presswizards.com/","logo_url":"https://api.pulsetic.com/uploads/upload_logos/Cr5pTsM2PdAbi4tdW0s8DsbG14p3UlGyyDetXogL.png"}


//////////////////
// WEBPACK FOOTER
// ./page_config.json
// module id = Yr1l
// module chunks = 1